import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import AlertDialog from "../AlertDialog";
import DiseaseDetailComponent from "../diseaseDetailComponent/DiseaseDetailComponent";

const useStyles = makeStyles((theme) => ({
  modalTitle: {
    padding: theme.spacing(3),
    color: theme.palette.secondary.main,
    wordBreak: "break-word",
  },
  dialogContent: {},
  modalButton: {
    margin: theme.spacing(2),
    border: "1px solid #FFF",
    backgroundColor: "#F3F2FC",
    borderRadius: 30,
    cursor: "pointer",
    padding: theme.spacing(1, 3),
    color: theme.palette.text.main + "!important",
    textTransform: "capitalize",
    "&:hover": {
      border: "1px solid #FF3185",
      backgroundColor: "#FFF6FA",
    },
  },
}));

const DiseaseDetailDialog = ({ diseaseId, title, handleCloseDiseaseModal, symptoms_score }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <AlertDialog
      open={!!diseaseId}
      buttonCloseText={intl.formatMessage({ id: "global_buttons_close" })}
      description={<DiseaseDetailComponent id={diseaseId} symptoms_score={symptoms_score} />}
      title={
        <Typography variant={"h4"} className={classes.modalTitle}>
          {title}
        </Typography>
      }
      onClose={handleCloseDiseaseModal}
      dialogClassName={classes.dialogContent}
      buttonClassName={classes.modalButton}
    />
  );
};

export default DiseaseDetailDialog;
